import { motion } from "framer-motion";
import { METHOD } from "@/data/content";
import { SectionHeading } from "./ui";
import { Reveal } from "./Reveal";

export default function MethodSection() {
  return (
    <section id="metodo" className="relative bg-brand-cream py-20 lg:py-32 grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <SectionHeading eyebrow={METHOD.eyebrow} title={METHOD.title} />

        <div className="mt-16 relative">
          {/* vertical line */}
          <div className="absolute left-[27px] top-2 bottom-2 w-px bg-brand-bordeaux/15 md:hidden" />
          <div className="hidden md:block absolute left-0 right-0 top-[46px] h-px bg-brand-bordeaux/15" />

          <div className="grid md:grid-cols-5 gap-8 md:gap-4">
            {METHOD.steps.map((s, i) => (
              <Reveal key={s.num} delay={i} className="relative">
                <div data-testid={`method-step-${s.num}`} className="flex md:flex-col gap-5 md:gap-0">
                  <div className="relative z-10 shrink-0">
                    <motion.div
                      initial={{ scale: 0 }}
                      whileInView={{ scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.1 * i, type: "spring", stiffness: 200 }}
                      className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-bordeaux font-mono text-sm text-brand-ivory"
                    >
                      {s.num}
                    </motion.div>
                  </div>
                  <div className="md:mt-6">
                    <h3 className="font-serif text-2xl text-brand-bordeaux">{s.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-brand-graphite/70 md:pr-4">{s.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={2}>
          <div className="mt-16 border-l-2 border-brand-gold pl-6 sm:pl-8">
            <p className="font-serif italic text-2xl sm:text-3xl lg:text-4xl text-brand-bordeaux leading-tight">
              “{METHOD.highlight}”
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
